import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router, CanActivateChild, RouterStateSnapshot } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthService } from '../services/auth.service';
import { LogService } from 'src/app/core/logger/logger_service';
import { ReferenceService } from 'src/app/services/reference.service';
import * as uuid from "uuid";
declare var window: any;
@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  referenceUUID: string | null = null;
  log_session_text: string = "auth guard line register";
  comcode = "insure";
  uuid = uuid.v4();
  constructor(private authService: AuthService,
    private router: Router,
    private logger: LogService,
    private referenceService:ReferenceService
  ) {
    if(typeof window !== 'undefined'){
      if (environment.log_level == "debug") { window.vConsole = new window.VConsole(); }
    }
    this.referenceUUID = this.referenceService.getReferenceUUID();
    this.log_session_text = `auth guard line register referenceUUID:[${this.referenceUUID}]`
  }

  async canActivate(route: ActivatedRouteSnapshot,state: RouterStateSnapshot): Promise<boolean> {
    // console.log(route.queryParamMap);
    try{
      const urlHref = window.location.href;
      this.logger.info(`${this.log_session_text} uuid:[${this.uuid}] auth guard line register urlHref:${urlHref}`);     
      this.logger.info(`${this.log_session_text} uuid:[${this.uuid}] auth guard line register currentURL:${this.router.url}`);
      this.logger.info(`${this.log_session_text} uuid:[${this.uuid}] auth guard line register targetURL:${state?.url}`);
      if(environment.production === false){
        // TISCO Block ทำให้ liff ไม่สามารถใช้งานได้ จึงต้อง bypass frontend 
        return true;
      }      
      // const liffId = route.queryParamMap.get("liffId") || route.queryParamMap.get("appRef");
      const qp = route.queryParamMap;
      const raw = new URLSearchParams(window.location.search)
      const liffId = qp.get('liffId') || qp.get('appRef') || raw.get('liffId') || raw.get('appRef');
      const channelLineId = qp.get('channel_line_id') || raw.get('channel_line_id');
      const liffChannelId = qp.get('liff_channel_id') || raw.get('liff_channel_id');
      if(channelLineId) {
        this.authService.setChannelLineId(channelLineId);
      }
      if(liffChannelId) {
        this.authService.setLiffChannelId(liffChannelId);
      }
      this.logger.info(`${this.log_session_text} uuid:[${this.uuid}] auth guard line register liff_id ${liffId}`)
      this.comcode = route.params.comcode;      
      await this.authService.initLiff(liffId);
      if (this.authService.getLoginStatus()) {
        this.logger.info(`${this.log_session_text} uuid:[${this.uuid}] auth guard line register getLoginStatus is true`)
        return true;
      } else {
        // Redirect to an appropriate page if needed
        // this.router.navigate(['/login']);
        this.logger.info(`${this.log_session_text} uuid:[${this.uuid}] auth guard line register getLoginStatus is false`)
        this.referenceService.setShowReference(true)
        this.authService.logout();
        this.authService.login();
        return false;
      }
    }catch(error){
      this.logger.error(`${this.log_session_text} uuid:[${this.uuid}] auth guard line register error:${error?.message}`)
      this.referenceService.setShowReference(true)
      this.router.navigate(["register/line/"+this.comcode+"/form-error"], { queryParams: { "status": "apifail", "code": "" } })
      return false;
    }    
  }
}
